import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Button} from 'react-bootstrap';
import Mousetrap from 'mousetrap';
import ReactTooltip from 'react-tooltip';
import ImageInfoTooltip, {createTooltipId} from '../containers/ImageInfoTooltip';

export default class ImageNav extends Component {
    static propTypes = {
        urlPrefix: PropTypes.string,
        imageInfo: PropTypes.object,
        prevId: PropTypes.number,
        nextId: PropTypes.number,
        currIdx: PropTypes.number,
        imageCount: PropTypes.number,
        history: PropTypes.object,
        preventKeyNavigation: PropTypes.bool,
    };

    static defaultProps = {
        urlPrefix: '',
    };

    componentDidMount() {
        Mousetrap.bind(['left'], (e) => {
            if (!this.props.preventKeyNavigation) {
                e.preventDefault();
                this.handlePrev();
            }
        });
        Mousetrap.bind(['right'], (e) => {
            if (!this.props.preventKeyNavigation) {
                e.preventDefault();
                this.handleNext();
            }
        });
    }

    componentWillUnmount() {
        // noinspection JSUnresolvedFunction
        Mousetrap.unbind(['left', 'right']);
    }

    handleNav = (id, e) => {
        if (e) {
            e.preventDefault();
        }
        const {history, urlPrefix} = this.props;
        history.push(`${urlPrefix}/image/${id}`);
    };

    handlePrev = (e) => {
        if (this.props.prevId) {
            this.handleNav(this.props.prevId, e);
        }
    };

    handleNext = (e) => {
        if (this.props.nextId) {
            this.handleNav(this.props.nextId, e);
        }
    };

    render() {
        const {imageInfo, nextId, prevId, currIdx, imageCount} = this.props;

        return (
            <div className="image-head">
                <div className="image-nav">
                    <Button
                        bsStyle="link" onClick={this.handlePrev} disabled={!prevId}
                        title={nextId ? '' : 'Previous image'}
                        data-tip data-for="upTooltip"
                    >
                        <i className="fa fa-chevron-circle-left"/>
                        {prevId &&
                        <ReactTooltip id="upTooltip" place="bottom" delayShow={400} className="light-tool-tip" type="light">
                            <div>{'Previous image'}</div>
                            <kbd>{'←'}</kbd>
                        </ReactTooltip>
                        }
                    </Button>
                    <div className="nav-counts pull-left">{`${currIdx + 1} of ${imageCount}`}</div>
                    <Button
                        bsStyle="link" onClick={this.handleNext} disabled={!nextId}
                        title={nextId ? '' : 'Next image'}
                        data-tip data-for="downTooltip"
                    >
                        <i className="fa fa-chevron-circle-right"/>
                        {nextId &&
                        <ReactTooltip id="downTooltip" place="bottom" delayShow={400} className="light-tool-tip" type="light">
                            <div>{'Next image'}</div>
                            <kbd>{'→'}</kbd>
                        </ReactTooltip>
                        }
                    </Button>
                </div>
                <div className="image-name" data-tip data-for={createTooltipId(imageInfo.id)}>
                    {imageInfo.fileName}
                    <ImageInfoTooltip id={imageInfo.id} type="light" showEditInfo={true} className="light-tool-tip"/>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/ImageNav.js